




































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import BaseDataTable from '@/components/BaseDataTable.vue';
import moment from 'moment';
import Auth from '@/connector/Auth.vue';
import BaseDateRangeSearch from '@/components/BaseDateRangeSearch.vue';
import TransactionService from '@/services/TransactionService';
import PromotionService from '@/services/PromotionService';

const transactionService = new TransactionService();
const promotionService = new PromotionService();

@Component({
  components: {
    BaseDataTable,
    Auth,
    BaseDateRangeSearch,
  },
})
export default class BetList extends Vue {
  public loading: boolean = false;

  public range: string = [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')].toString();

  public transactions: number = 0;

  public summary: number | string = 0;

  public promotions: Array<any> = [];

  public selectedPromotion: string = '';

  // eslint-disable-next-line class-methods-use-this
  public formatDate(time: number) {
    return moment(time).format('YYYY-MM-DD HH:mm:ss');
  }

  async search(data: any) {
    this.range = data;
  }

  @Watch('range')
  async onRangeChange() {
    await this.getPromotionSummary();
  }

  @Watch('selectedPromotion')
  async onSelectedPromotionChange() {
    await this.getPromotionSummary();
  }

  get dateText() {
    const date = this.range.split(',');
    return `${date[0]} - ${date[1]}`;
  }

  // eslint-disable-next-line class-methods-use-this
  get transactionUrl() {
    return `${process.env.VUE_APP_API_ENDPOINT}/transactions`;
  }

  public async getPromotionSummary() {
    const { data } = await transactionService.getSummaryByType({
      range: this.range,
      type: 'promotion',
      // eslint-disable-next-line @typescript-eslint/camelcase
      promotion_id: this.selectedPromotion,
    });
    this.transactions = data.transactions;
    this.summary = Number(data.summary).toFixed(2);
  }

  // eslint-disable-next-line class-methods-use-this
  get promotionListUrl() {
    return `${process.env.VUE_APP_API_ENDPOINT}/promotions`;
  }

  async created() {
    await this.getPromotionSummary();
    const { data } = await promotionService.getPromotions();
    this.promotions = [...data];
  }
}
